<template>
  <div>
    <stockitems
    :stockitems="stockItems"
      :stocktypes="stockTypes"
      @stockItemChange="getStockItems()"
    ></stockitems>
  </div>
</template>

<script>
import Api from "@/services/Api";
import StockItem from "@/components/StockItem.vue";

export default {
  components: {
    stockitems: StockItem
  },
  data() {
    return {
        stockItems: [],
      stockTypes: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getStockItems();
        this.getStockTypes();
      
    },
    getStockItems(){
        Api()
        .get("/stockItem")
        .then(response => {
          this.stockItems = response.data;
        });
    },
    getStockTypes() {
      Api()
        .get("/stockType")
        .then(response => {
          this.stockTypes = response.data;
        });
    }
  }
};
</script>

<style>
</style>